import * as React from 'react';
import { FormikProps, Field, Form, withFormik } from 'formik';
import * as Yup from 'yup';

import './Login.scss';
import { connect } from 'react-redux';
import { loginUser } from 'src/store/auth/actions';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { ApplicationState } from 'src/store';

interface FormValues {
  username: string;
  password: string;
}

interface Props {
  loginUser: typeof loginUser;
  loading: boolean;
}

class LoginForm extends React.PureComponent<FormikProps<FormValues> & Props> {
  public render() {
    const { isSubmitting, touched, errors, isValid, loading } = this.props;
    return (
      <div className="container">
        <Form className="col-lg-6 centered loginForm">
          <h1>ANMELDUNG</h1>
          <div className="row">
            <div className="col-12 flex-container">
              <label>Benutzername:</label>
              <Field
                name="username"
                className={touched.username && errors.username ? 'inputError' : ''}
              />
              {touched.username && errors.username && (
                <div className="error">{errors.username}</div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12 flex-container">
              <label style={{ width: '188px', textAlign: 'left' }}>Passwort:</label>
              <Field
                type="password"
                name="password"
                className={touched.password && errors.password ? 'inputError' : ''}
              />
              {touched.password && errors.password && (
                <div className="error">{errors.password}</div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <button type="submit" disabled={isSubmitting || !isValid}>
                Login
              </button>
            </div>
          </div>
        </Form>
        <LoadingSpinner pending={loading} />
      </div>
    );
  }
}

const validationSchema = Yup.object().shape({
  username: Yup.string()
    .max(255)
    .required('Benutzername ist erforderlich'),
  password: Yup.string()
    .max(255)
    .required('Passwort ist erforderlich')
});

const LoginView = withFormik<Props, FormValues>({
  validationSchema,
  mapPropsToValues: () => ({ username: '', password: '' }),
  handleSubmit: (values: FormValues, { props, setSubmitting }) => {
    props.loginUser(values.username, values.password);
    setSubmitting(false);
  }
})(LoginForm);

const mapStateToProps = ({ auth }: ApplicationState) => ({
  loading: auth.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  loginUser: (username: string, password: string) => dispatch(loginUser(username, password))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginView);



// WEBPACK FOOTER //
// ./src/pages/Login/Login.tsx